import { Injectable } from '@angular/core';
import { Headers, RequestOptions } from '@angular/http';
import { User, UserPatch, UserPinnedAppsPatch, UserProfilePatch } from 'ri-api-client';
import { Observable } from 'rxjs/Observable';
import { ApiService } from '../api.service';
import { ActivityLogCollection } from 'ri-api-client';

@Injectable()
export class UserService {
    private options: any;

    constructor(
        private apiService: ApiService
    ) {
        const headers = new Headers({ 'Content-Type': 'application/json' });
      this.options = new RequestOptions({ headers: headers });
      this.apiService.init();
    }

    getUsers(fields?: string, filter?: string, sort?: string, page?: string, archived?: boolean): Observable<User.User[]> {
      return this.apiService.client.users.GET(fields, filter, sort, page, archived, this.options)
        .map((res) => {
            return this.apiService.handleResponse(res).results;
        });
    }

    getUser(id: number): Observable<User.User> {
      return this.apiService.client.users.id(id.toString()).GET(null, this.options)
        .map((res) => {
            return this.apiService.handleResponse(res);
        });
    }

    post(user: User.User): Observable<any> {
        return this.apiService.client.users.POST(user, this.options)
        .map((res) => {
            return this.apiService.handleResponse(res);
        });
    }

    update(user: User.User) {
        // We are doing this because TypeScript does not restrict extra properties.
        const userPatch: UserPatch.UserPatch = {
            lastName: user.lastName,
            firstName: user.firstName,
            sapLogin: user.sapLogin,
            email: user.email,
            permissionGroupIds: user.permissionGroupIds
        };
        return this.apiService.client.users.id(user.id.toString()).PATCH(userPatch, this.options).map((res) => {
            return this.apiService.handleResponse(res);
        });
    }

    updateProfile(user: User.User) {
        // We are doing this because TypeScript does not restrict extra properties.
        const userProfile: UserProfilePatch.UserProfilePatch = {
            lastName: user.lastName,
            firstName: user.firstName,
            locale: user.locale,
            timeZone: user.timeZone,
            password: user.password,
            newPassword: user.newPassword
        };
        return this.apiService.client.users.id(user.id.toString()).profile.PATCH(userProfile, this.options).map((res) => {
            return this.apiService.handleResponse(res);
        });
    }

    updatePinnedApps(user: User.User) {
        // We are doing this because TypeScript does not restrict extra properties.
        const userPinnedApps: UserPinnedAppsPatch.UserPinnedAppsPatch = {
            pinnedAppIds: user.pinnedAppIds
        };
        return this.apiService.client.users.id(user.id.toString()).pinnedApps.PATCH(userPinnedApps, this.options).map((res) => {
            return this.apiService.handleResponse(res);
        });
    }

    activate(user: User.User): Observable<any[]> {
        return this.apiService.client.users.id(user.id.toString()).activate.PATCH(this.options)
        .map((res) => {
            return this.apiService.handleResponse(res);
        });
    }

    unlock(user: User.User): Observable<any[]> {
        return this.apiService.client.users.id(user.id.toString()).unlock.PATCH(this.options)
            .map((res) => {
                return this.apiService.handleResponse(res);
            });
    }

    delete(user: User.User): Observable<any[]> {
        return this.apiService.client.users.id(user.id.toString()).DELETE(this.options)
        .map((res) => {
            return this.apiService.handleResponse(res);
        });
    }

    getCurrent(): Observable<User.User> {
        return this.apiService.client.users.current.GET(this.options)
            .map((res) => {
                return this.apiService.handleResponse(res);
            });
    }

    getActivityLogs(fields?: string, filter?: string, sort?: string, page?: string): Observable<ActivityLogCollection.ActivityLogCollection> {
        return this.apiService.client.activityLogs.GET(fields, filter, sort, page, this.options)
            .map((res) => {
                return this.apiService.handleResponse(res);
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/core/api/user.service.ts